$('body').on('fx-ready', function(event) {
    $target = $(event.target);

    // init Filament Groups appendAround (vor allem RiLi-Detailseite für sub-nav)
    $target.find('.js-appendaround').appendAround();
});
